import { values } from '@fortem-monorepo/js-utilities';
export const CONTRACT_TYPE = {
    Digital: 'Digital',
    Call: 'Call',
    Put: 'Put',
};
export const CONTRACT_TYPES = values(CONTRACT_TYPE);
